import api from '../token';

export const AddUnidade = async (dados) => {
  try {
    const response = await api.post('/addUnidade', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};









